<section class="container">
<div
  class="card service-card container my-5 py-4 px-3 px-md-4 rounded-4 shadow-lg"
  *ngFor="let item of data.details.services; let i = index"
>
  <div class="row g-4 align-items-center justify-content-center">
    <div class="col-12" *ngIf="i === 0 && data?.details.title">
      <h3 class="section-title text-center mb-4">
        {{ data.details.title.split(" ")[0] }}
        <span>{{ data.details.title.split(" ").slice(1).join(" ") }}</span>
      </h3>
    </div>

    <div class="col-12 col-md-5 text-center d-flex align-items-center justify-content-center">
      <img
        class="service-img rounded-4"
        [src]="item.imageIconPath"
        [alt]="item.imageAlt"
        loading="lazy"
        (click)="openImage(item.imageIconPath)"
      />
    </div>

    <div class="col-12 col-md-7 d-flex flex-column justify-content-center align-items-start px-md-4">
      <h1 class="service-title mb-3">{{ item.titleTr }}</h1>
      <div class="summary-content mb-3" [innerHTML]="item.summary"></div>
      <a
         class="details-btn mt-2"
        [href]="getDetailsUrl(item)"
        *ngIf="data.details.isDetails"
      >
        {{ "View More" | translate }}
      </a>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="imageModal"
  tabindex="-1"
  aria-hidden="true"
  #imageModalRef
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-body p-0 position-relative">
        <button
          type="button"
          class="btn-close position-absolute top-0 end-0 m-3"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
        <img
          [src]="selectedImage"
          class="img-fluid rounded-4 w-100"
          alt="Preview"
        />
      </div>
    </div>
  </div>
</div>
</section>